import { mapState } from 'vuex'
import ApiService from '@/services/apis.service'
import SaleService from '@/services/sale.service'

export default {
    name: 'PostPaidPackageList',
    data () {
        return {
            dataTable: [],
            apiList: [],
            projectList: [],
            dataFilters: {
                project: '',
                api: '',
                status: '',
                type: '',
                viewCanceled: false
            },
            pagination: {
                page: 1,
                rowsPerPage: 10,
                sortBy: 'name',
                descending: false
            },
            updating: false,
            fireUpdate: false
        }
    },
    computed: {
        ...mapState({
            projects: state => state.user.projects
        }),
        postpaidTypeList () {
            return [
                {
                    text: this.$t('postpaidRelated.' + this.$const.LIMIT_USAGE),
                    value: this.$const.LIMIT_USAGE
                },
                {
                    text: this.$t('postpaidRelated.' + this.$const.NO_LIMIT_USAGE),
                    value: this.$const.NO_LIMIT_USAGE
                }
            ]
        },
        packageStatusList () {
            const statusList = [
                {
                    text: this.$t('postpaidRelated.' + this.$const.DRAFT),
                    value: this.$const.DRAFT
                },
                {
                    text: this.$t('postpaidRelated.' + this.$const.WAITING),
                    value: this.$const.WAITING
                },
                {
                    text: this.$t('postpaidRelated.' + this.$const.ACTIVE),
                    value: this.$const.ACTIVE
                },
                {
                    text: this.$t('postpaidRelated.' + this.$const.COMPLETED),
                    value: this.$const.COMPLETED
                },
                {
                    text: this.$t('postpaidRelated.' + this.$const.CANCELED),
                    value: this.$const.CANCELED
                }
            ]
            for (let status of statusList) {
                status.text = this.$filters.capitalize(status.text)
            }
            return statusList
        },
        headers () {
            const headers = [
                {
                    text: this.$t('packageName'),
                    value: 'name',
                    sortable: true
                },
                {
                    text: this.$t('packageType'),
                    value: 'limit_type',
                    $value: item => this.$t('postpaidRelated.' + item.limit_type),
                    sortable: true
                },
                {
                    text: this.$t('status'),
                    type: 'custom',
                    id: 'status',
                    value: 'status',
                    sortable: true
                },
                {
                    text: this.$t('project'),
                    value: 'project',
                    $value: item => item.project_api ? item.project_api.project_name : ''
                },
                {
                    text: this.$t('api'),
                    value: 'api',
                    $value: item => item.project_api.api_name
                },
                {
                    text: this.$t('maxUsage'),
                    value: item => {
                        const value = item.limit_type === this.$const.LIMIT_USAGE ? item.config.limit : ''
                        return this.$filters.formatNumber(value)
                    }
                },
                // {
                //     text: this.$t('currentUsage'),
                //     value: item => item.current_usage,
                //     sortable: false
                // },
                {
                    text: this.$t('remainUsage'),
                    value: 'remain_usage',
                    $value: item => {
                        let value = ''
                        if (item.limit_type === this.$const.NO_LIMIT_USAGE) {
                            value = this.$t('postpaidRelated.Unlimit')
                        } else if (item.remain_usage && item.remain_usage.paid) {
                            value = Math.max(0, Number(item.remain_usage.paid.remaining))
                        }
                        return this.$filters.formatNumber(value)
                    }
                },
                {
                    text: this.$t('unit'),
                    value: 'unit',
                    $value: item => this.$t(ApiService.getApiUnit(item.project_api.api_code))
                },
                {
                    text: this.$t('unitPrice'),
                    id: 'unitPrice',
                    type: 'custom',
                    value: 'unitPrice'
                },
                {
                    text: this.$t('price'),
                    value: 'price',
                    $value: item => this.$filters.formatNumber(
                        item.limit_type === this.$const.LIMIT_USAGE
                            ? item.config.limit * item.config.unit_price[0].price
                            : ''
                    ),
                    class: 'font-weight-bold'
                },
                {
                    text: this.$t('startDate'),
                    value: 'start_time',
                    sortable: true
                },
                {
                    text: this.$t('endDate'),
                    value: 'end_time',
                    sortable: true
                }
            ]

            return this.$appService.correctHeaders(headers)
        }
    },
    mounted () {
        this.$appService.hideLoading()
        this.loadProjects()
        this.loadApis()
        this.loadPackages()
    },
    methods: {
        loadApis () {
            SaleService.getSaleApis().then(
                result => {
                    this.apiList = result.data
                },
                this.$appService.handleRequestError(this.$t('canNotLoadApiList'))
            )
        },
        loadProjects () {
            // to be implemented by inheritor
        },
        loadPackages () {
            // to be implemented by inheritor
        },
        toPageDetails (packageItem) {
            this.$refs.PostPaidPackageDetails.open(packageItem)
        }
    },
    watch: {
        dataFilters: {
            deep: true,
            handler: function (val) {
                if (val.status === this.$const.CANCELED) {
                    this.dataFilters.viewCanceled = true
                }
                this.pagination.page = 1
                this.$nextTick(() => this.loadPackages())
            }
        },
        pagination: {
            handler: function () {
                this.loadPackages()
            }
        }
    }
}
